import { env } from './env';
import { toast } from './toast';
export * from './constants';

export const config = {
  env,
  toast,
};
